import { tryOnMounted, tryOnUnmounted } from '@vueuse/core';
import { useSocketStore } from '@/stores/socket';

export function useRegisterSockets(event, callBack, context = null) {
  const socketStore = useSocketStore();

  tryOnMounted(() => {
    socketStore.addListener(event, callBack, context);
  });

  tryOnUnmounted(() => {
    socketStore.removeListener(event, callBack, context);
  });
}
